import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from "react-helmet-async";
import { useLocales } from "../locales";
import Login from "../sections/auth/Login";
// ----------------------------------------------------------------------
export default function LoginPage() {
    const { translate } = useLocales();
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${translate("Login")} | RentalSaga` }) }), _jsx(Login, {})] }));
}
